// extracted by css-extract-rspack-plugin
export default {"emphasize":"emphasize-xyDYYn"};